import { useContext, useMemo } from 'react';
import type { FormattedMemberPromotion } from '@library/types/members/memberPromotions';
import { MemberPromotionTableContext } from '@bo-hooks/members';

export interface MemberPromotionsRowProps {
  memberPromotion: FormattedMemberPromotion;
}

export const MemberPromotionsRow = ({
  memberPromotion
}: MemberPromotionsRowProps) => {
  const {
    endDate,
    endTime,
    fundType,
    name,
    optedInAtDate,
    optedInAtTime,
    promotionId,
    promotionType,
    redeemedAtDate,
    redeemedAtTime,
    startDate,
    startTime
  } = memberPromotion;

  const { memberPromotionTypeOptions, onClickPromotion } = useContext(
    MemberPromotionTableContext
  );

  const promotionTypeDisplay = useMemo(() => {
    const promotionTypeOption = memberPromotionTypeOptions.find(
      (option) => (option.value as string) === promotionType
    );
    return promotionTypeOption?.label || promotionType;
  }, [promotionType, memberPromotionTypeOptions]);

  return (
    <div
      aria-hidden="true"
      className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 text-2xs relative flex h-full min-h-16 cursor-default items-center border-b xl:text-xs"
      data-testid={`memberPromotion-${promotionId}`}
      onClick={() => onClickPromotion({ promotionId })}
      role="button"
    >
      <p className="w-[5%] px-3" data-testid="member-promotion-id">
        {promotionId}
      </p>
      <p className="w-[10%] px-3" data-testid="member-promotion-type">
        {promotionTypeDisplay}
      </p>
      <p className="w-1/5 px-3" data-testid="member-promotion-name">
        {name}
      </p>
      <p className="w-[10%] px-3" data-testid="member-promotion-fundType">
        {fundType}
      </p>
      <div className="w-[15%] px-3">
        <p data-testid="member-promotion-startDate">{startDate}</p>
        <p
          className="text-soClean-160"
          data-testid="member-promotion-startTime"
        >
          {startTime}
        </p>
      </div>
      <div className="w-[15%] px-3">
        <p data-testid="member-promotion-endDate">{endDate}</p>
        <p className="text-soClean-160" data-testid="member-promotion-endTime">
          {endTime}
        </p>
      </div>
      <div className="w-[15%] px-3" data-testid="member-promotion-">
        <p data-testid="member-promotion-optedInAtDate">{optedInAtDate}</p>
        <p
          className="text-soClean-160"
          data-testid="member-promotion-optedInAtTime"
        >
          {optedInAtTime}
        </p>
      </div>
      <div className="w-[10%] px-3">
        <p data-testid="member-promotion-redeemedAtDate">{redeemedAtDate}</p>
        <p
          className="text-soClean-160"
          data-testid="member-promotion-redeemedAtTime"
        >
          {redeemedAtTime}
        </p>
      </div>
    </div>
  );
};
